module.exports = __webpack_public_path__ + "static/media/Spectrophotometer-vector.fcb210a8.svg";